import React, { useState } from 'react'
import { Button, Card, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import { HeroType } from '../../config'
import { getHeroConfigs, saveConfigDelay } from '../../modules/hero'
import WrappedDelayForm from './DelayForm'

const Delay = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [heroType, setHeroType] = useState('')

  const { heroConfigList } = useSelector(
    (state) => ({
      heroConfigList: state.hero.heroConfigList
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getHeroConfigs())
    }

    fetch()
  }, [])

  const columns = [
    {
      title: 'Hero Type',
      key: 'heroType',
      dataIndex: 'heroType',
      render: (text, record) => <span>{HeroType[text].title}</span>
    },
    {
      title: 'Delay (วินาที)',
      key: 'delaySec',
      dataIndex: 'delaySec',
      render: (text, record) => <span>{text}</span>
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
    setHeroType(HeroType[record.heroType].title)
  }

  const onCloseModal = async () => {
    await setVisible(false)
    await setFormData({})
    await setHeroType('')
  }

  const onOk = async (data) => {
    await dispatch(saveConfigDelay(data))
    await dispatch(getHeroConfigs())
    await setVisible(false)
  }

  return (
    <Card title="Transaction Delay">
      <Table
        bordered
        dataSource={heroConfigList}
        columns={columns}
        rowKey={(record) => {
          return record.id
        }}
      />
      <WrappedDelayForm
        heroType={heroType}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default Delay



// WEBPACK FOOTER //
// ./src/pages/Delay/index.js